import { render, staticRenderFns } from "./CrewView.vue?vue&type=template&id=fa05e93a&scoped=true&"
import script from "./CrewView.vue?vue&type=script&lang=js&"
export * from "./CrewView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa05e93a",
  null
  
)

export default component.exports